// Müşteri dizini sayaçları. Liste ekranı ve ana sayfa aynı sayıyı gösterir,
// bu yüzden sorgu anahtarı tek yerde: iki ekran arasında gezinmek ikinci bir
// istek (ve ikinci bir operator.tenant_directory_read denetim satırı) üretmez.
//
// Sayı sunucunun `total` alanıdır (filtreye uyan TÜM küme). Görünen sayfadaki
// satırları saymak, sayfa boyundan büyük kümede yanlış bir "toplam" verirdi.

import { queryOptions } from "@tanstack/react-query";

import { unwrap } from "@/api/envelope";
import { operatorGraph } from "@/api/operator-graph";
import type { paths } from "@/api/types.gen";

type TenantState = NonNullable<
  NonNullable<paths["/ops/v1/tenants"]["get"]["parameters"]["query"]>["state"]
>;

export type TenantCountScope = TenantState | "all";

export function tenantCountQueryOptions(scope: TenantCountScope) {
  return queryOptions({
    queryKey: ["operator", "tenants", "count", scope] as const,
    queryFn: async (): Promise<number> => {
      const data = await unwrap(
        operatorGraph.GET("/ops/v1/tenants", {
          params: { query: { limit: 1, ...(scope !== "all" ? { state: scope } : {}) } },
        }),
      );
      return data.total;
    },
    staleTime: 5 * 60_000,
  });
}
